import { useCurrentSubscription } from "@dashboard/workspaces/api/helpers";

import { useGetFdroidsQuery } from "./index";

function useGetCurrentWorkspaceFdroids() {
    const { data: subscription } = useCurrentSubscription({});
    const noSubscription = !subscription?.id;
    const isTerminated = subscription?.status === "Terminated";
    return useGetFdroidsQuery({ subscriptionId: subscription?.id, isTerminated }, { skip: noSubscription });
}

export { useGetCurrentWorkspaceFdroids };
